// extracted by mini-css-extract-plugin
export default {"header":"answer-list-loading_header__NoB00","body":"answer-list-loading_body__hUjR4"};